import { useState, useEffect } from 'react';
import { CONTRACT_PROVIDER_PAY } from 'src/constants/ehrFeatureFlags';
export var useContractProviderPayFlag = function (isFetched, ehrFeatures) {
    if (ehrFeatures === void 0) { ehrFeatures = ''; }
    var _a = useState(false), providerPayEnabled = _a[0], setProviderPayEnabled = _a[1];
    useEffect(function () {
        if (isFetched) {
            if (ehrFeatures.includes(CONTRACT_PROVIDER_PAY)) {
                setProviderPayEnabled(true);
            }
        }
    }, [ehrFeatures, isFetched]);
    return providerPayEnabled;
};
